import { useMutation } from 'react-query'

import { addComment } from '../../endpoints/tickets'

export const useAddComment = () => {
    return useMutation(async (payload: FormData) => await addComment(payload))
}
